import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, NgForm  } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { ToastService } from '../../shared/services/toast.service';
import {TranslateService} from '@ngx-translate/core';
import { StaticValueService } from '../../shared/services/static-value.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  public password;
  public confirmPassword;
  public passwordMatchBool: Boolean = false;
  public user_id: string;
  public username;
  public authString;
  public mode;
  public originalPassword; // only used in case of change password
  public language = 'english';


  
  constructor( public fb: FormBuilder,
    public route: ActivatedRoute,
    public authService: AuthService,
    public toastService: ToastService,
    public translateService: TranslateService,
    public staticService: StaticValueService,
    public router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.user_id = params['id'];
      this.mode = params['mode'];
      this.authString = params['random-string'];
      this.authService.getUser(this.user_id).subscribe(data => {
        let user = data[0];
        this.username = user.username;
        console.log(this.authString);
        console.log('forgot password', user.forgotPasswordString);
        if (this.authString === user.forgotPasswordString) {} else {
          this.router.navigate(['../login']);
          this.toastService.error('Link Expired');
        }
      }, error => {});
    });



    if (this.staticService.getLanguage()) {
      this.translateService.use(this.staticService.getLanguage());
      this.language = this.staticService.getLanguage();
  }else {
      this.translateService.use('english')
      this.translateService.setDefaultLang('english');
  }
  }

  passwordMatch() {
    if (this.password === this.confirmPassword) {
      this.passwordMatchBool = false;
    } else {
      this.passwordMatchBool = true;
    }
  }

  updatePassword() {
    let user = {};
    user['username'] = this.username;
    user['password'] = this.password;
    user['userId'] = this.user_id;
    user['mode'] = 'Forgot Password';

    let userConfirmPassword = {
      email : this.username,
      password : this.originalPassword,
      isProxyUser : false
    }




    if (this.mode === 'change' ) {
      user['submode'] = 'Change Password';
      this.authService.login(userConfirmPassword).then(data => {
        this.authService.signup(user).subscribe(data => {
          this.router.navigate(['../login']);
          this.toastService.success();
        }, error => {
          this.toastService.error('Sign-up unsuccessful');
          console.log('error', error);
        })
      }).catch(e => {
        this.toastService.error('Incorrect current password')
      });  
    } else {
      this.authService.signup(user).subscribe(data => {
        this.router.navigate(['../login']);
        this.toastService.success();
      }, error => {
        this.toastService.error('Sign-up unsuccessful');
        console.log('error', error);
      })
    }

  }


  languageChange(lang:string){
    this.translateService.use(lang);
    this.language=lang;
    this.staticService.setLanguage(lang);
  }
}
